import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum Channel {
  sms = 'sms',
  whatsapp = 'whatsapp',
  viber = 'viber',
}

interface OverviewState {
  channel: Channel;
}

const initialState: OverviewState = { channel: Channel.sms };

const overviewSlice = createSlice({
  name: 'overview',
  initialState,
  reducers: {
    setChannel: (state, action: PayloadAction<Channel>) => {
      state.channel = action.payload;
    },
  },
});

export const { setChannel } = overviewSlice.actions;

export default overviewSlice.reducer;
